export enum BannerStatus {
  Draft = 10,
  Published = 20,
  Archived = -10,
}
